(function ($, Drupal) {

  'use strict';

  Drupal.behaviors.droopler_subtheme = {
    attach: function (context, settings) {

      // TODO: move this code to a separate library included when "table" detected.
      once('droopler_subtheme', '.table-fixed-column-left', context).forEach((item) => {
        var $table = $(item);
        // Let's wrap the table in a div, and copy table classes to that div
        // This will help styling it.
        $table.wrap('<div class="fixed-table-container"></div>').wrap('<div class="fixed-table-wrapper"></div>');
        $table.parent().addClass($table.attr('class'));
        // Let's clone the table for a "fixed left column" functionality.
        $table.clone(true).appendTo($table.parent().parent()).addClass('clone');
      });

    }
  };

  Drupal.behaviors.showText = {
    attach: function (context, settings) {
      $(".text-formatted", context).each(function () {
        $(this).find(".trigger-expand").click(function (e) {
          e.preventDefault();
          var $this = $(this);
          // Apply 'slide' animation to all expandable-text inside this parent
          $this.siblings(".expandable-text").slideToggle(250);
          // Toggle class for current parent
          $this.toggleClass("clicked");
          // Depends on whether it is clicked or not. It will change text if data tag is available
          $this.text($this.hasClass("clicked") ? $this.data("text-less") : $this.data("text-more"));
        });
      });
    }
  };

  Drupal.behaviors.tooltip = {
    attach: function (context, settings) {
      var $ters_info = $('.terms_info').html();
      $('.terms a').tooltip({
        placement: "bottom",
        html: true,
        title: $ters_info,
        trigger: "manual",
      }).on("mouseenter", function () {
        var _this = this;
        $(this).tooltip("show");
        $(".tooltip", context).on("mouseleave", function () {
          $(_this).tooltip('hide');
        });
      }).on("mouseleave", function () {
        var _this = this;
        setTimeout(function () {
          if (!$(".tooltip:hover", context).length) {
            $(_this).tooltip("hide");
          }
        }, 300);
      });
    }
  };

  Drupal.behaviors.google_analytics = {
    attach: function (context, settings) {
      window.dataLayer = window.dataLayer || [];
      // Selected text.
      var sText = '';
      // On link / area click.
      $('a, area').on('click', function () {
        // Check if link contains email.
        if ($(this).is("a[href^='mailto:'], area[href^='mailto:']")) {
          // Send GA event.
          window.dataLayer.push({
            'event': 'contactpage_mail_click',
            'hitType': 'event',
            'eventCategory': 'Mails',
            'eventAction': 'Click',
            'eventLabel': this.href.substring(7),
            'transport': 'beacon'
          });
        }
      });

      // Mouse up to check selected text.
      document.onmouseup = function () {
        // Reset.
        sText = '';

        // Get selected text.
        if (window.getSelection) {
          sText = window.getSelection().toString();
        } else if (document.selection && document.selection.type !== "Control") {
          sText = document.selection.createRange().text;
        }

        // Check if we did get that text.
        if (sText.length <= 1) {
          return;
        }

        // Replace any new line char.
        sText = sText.trim().replace('\n', '');

        // Check if given text
        if (isEmailValid(sText)) {
          // Send GA event.
          window.dataLayer.push({
            'event': 'contactpage_mail_select',
            'hitType': 'event',
            'eventCategory': 'Mails',
            'eventAction': 'Select',
            'eventLabel': sText,
            'transport': 'beacon'
          });
        }
      };
    }
  };

  Drupal.behaviors.stickMenu = {
    attach: function (context, settings) {
      $('.navbar.stick', context).each(function () {
        var $menu = $(this);
        var lastScrollTop = 0;
        var offset = $menu.data('offset-top') || 0;

        $(window).scroll(function () {
          var direction = window.pageYOffset || document.documentElement.scrollTop;
          let event_name = false;

          if (direction > offset + $menu.outerHeight() && !$menu.hasClass('stick-initialized')) {
            $menu.addClass('stick-initialized');
            event_name = 'sticky:init';
          }
          else if (direction <= offset + $menu.outerHeight() && $menu.hasClass('stick-initialized')) {
            $menu.removeClass('stick-initialized');
            event_name = 'sticky:destroy';
          }
          if (direction < lastScrollTop && $menu.hasClass('stick-menu-hidden')) {
            event_name = 'sticky:attach';
          } else if (direction >= lastScrollTop && !$menu.hasClass('stick-menu-hidden')) {
            event_name = 'sticky:detach';
          }
          direction < lastScrollTop ? $menu.addClass('stick-direction-top').removeClass('stick-menu-hidden') : $menu.removeClass('stick-direction-top').addClass('stick-menu-hidden');
          lastScrollTop = direction <= 0 ? 0 : direction;
          if (event_name) {
            $(window).trigger(event_name);
          }
        });
      });
    }
  };

  Drupal.behaviors.mautic = {
    attach: function (context, settings) {
      $('#mauticform_newsletter', context).on('reset', function () {
        $('#mauticform_newsletter').html('<h2>Thank you!</h2>');
      });
    }
  };

  Drupal.behaviors.mautic = {
    attach: function (context, settings) {
      $('#mauticform_newsletterpl', context).on('reset', function () {
        $('#mauticform_newsletterpl').html('<h2>Dziękujemy!</h2>');
      });
    }
  };

  Drupal.behaviors.setColumns = {
    attach: function (context, settings) {
      once('setColumns', '.paragraph_d_p_services__menu-links', context).forEach((item) => {
        const parent = $(item);
        const children = parent.children('div');
        if (children.length < 5) {
          parent.addClass('one-column');
        }
      })
    }
  }
  /**
   * Function for email validation.
   *
   * @param email
   *   String input.
   *
   * @returns {boolean}
   *   True if given value is email, false otherwise.
   */
  function isEmailValid(email) {
    return /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(email);
  }

  Drupal.behaviors.accordionItemOpenFirst = {
    attach: function (context, settings) {
      once('accordionItemOpenFirst', '.accordion__content', context).forEach((item) =>  {
        const parent = $(item);
        const children = $(this).find('.first-item');
        if (children.length > 0) {
          children.find('.accordion__tab').addClass('show');
        }
      });
    }
  }

  Drupal.behaviors.jobOfferImages = {
    attach: function (context, settings) {
      $(".text-block-job-offer .wrapper-d_p_single_text_block", context).each(function () {
        const url = $(this).find(".field--name-field-d-cta-link a.btn").attr('href');
        $(this).find(".field--name-field-d-media-icon img").wrap('<a href="' + url + '"></a>')
      })
    }
  }

  Drupal.behaviors.menuPositioning = {
    attach: function (context, settings) {
      const desktopBreakpoint = 992;
      const xlBreakpoint = 1200;
      let $menuTab = $("li.we-mega-menu-li[data-level='0']");

      if ($(window).width() > desktopBreakpoint) {
        $menuTab.each(function () {
          let $this = $(this);
          let $menuFirstLevel = $this.children("div.we-mega-menu-submenu");

          if ($menuFirstLevel.length) {
            let menuTabWidth = $this.width();
            let firstLevelWidth = $menuFirstLevel.width();
            let newMenuPosition = -((firstLevelWidth - menuTabWidth) / 2);

            $menuFirstLevel.css('left', newMenuPosition + 'px');

            let $menuLastLevel = $menuFirstLevel.find("li.we-mega-menu-li[data-level='2'] > div.we-mega-menu-submenu");
            if ($menuLastLevel.length && $(window).width() < xlBreakpoint) {
              $menuLastLevel.css('min-width', 'unset');
            }
          }
        });

        // Here we handle the last element (i.e. Blog Tab), as it went off the screen
        $("li.we-mega-menu-li[data-level='0']:last-child > div.we-mega-menu-submenu").css('min-width', 'unset');
      }
    }
  }

  Drupal.behaviors.customMegaMenuStyles = {
    attach: function (context, settings) {
      let submenuInners = document.querySelectorAll('.we-mega-menu-submenu-inner');
      submenuInners.forEach(function(submenuInner) {
        let submenuElement = submenuInner.querySelector('.we-mega-menu-row > .we-mega-menu-col > .subul > .we-mega-menu-li.with-submenu');

        if (!submenuElement) {
          submenuInner.setAttribute('style', 'overflow-y: auto !important; overflow-x: hidden !important; overscroll-behavior: none;');
        }
      });
    }
  };

})(jQuery, Drupal);
